export const INTERVAL_AGENT_PULLING_TIME = 2000

const MINUTES_TO_MS = 60 * 1000

const FOUR_MINUTES = 4
const TWO_MINUTES = 2
const EIGHT_MINUTES = 8
const TEN_MINUTES = 10

export const USER_INACTIVITY_CHAT_TIMEOUT = TEN_MINUTES * MINUTES_TO_MS
export const USER_INACTIVITY_CHAT_WARNING = EIGHT_MINUTES * MINUTES_TO_MS

export const USER_INACTIVITY_AGENT_TIMEOUT = FOUR_MINUTES * MINUTES_TO_MS
export const USER_INACTIVITY_AGENT_WARNING = TWO_MINUTES * MINUTES_TO_MS

export const MINUTES_TO_TIMEOUT = 2
